import { createBrowserHistory, createMemoryHistory } from 'history';

export const createHistory = (context: string, location: string = '') => {
	const history = context === 'client' ? createBrowserHistory() : createMemoryHistory({ initialEntries: [location] });
	return history;
};
